import React, { FC, useState } from "react";
import DatePicker, { DatePickerProps } from "./Date";
import { PanelMode } from "rc-picker/lib/interface";
import isAfter from "date-fns/isAfter";

const Birthday: FC<DatePickerProps> = ({ ...props }) => {
  const [today] = useState<Date>(new Date());
  const [panel, setPanel] = useState<PanelMode>("decade");

  const onPanelChange = (date: Date, panel: PanelMode) => {
    setPanel(panel);
  };
  const onOpenChange = (isOpen: boolean) => {
    if (!isOpen) setPanel("decade");
  };

  return (
    <DatePicker
      {...props}
      style={{ width: "100%", ...props.style }}
      format={"dd-MM-yyyy"}
      mode={panel}
      disabledDate={(date) => isAfter(date, today)}
      onOpenChange={onOpenChange}
      onPanelChange={onPanelChange}
    />
  );
};

export default Birthday;
